import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import css from 'styled-jsx/css';
import cx from 'classnames';

const getTypeClass = type => {
  if (type === 'regular') {
    return 'regular';
  }

  if (type === 'light') {
    return 'light';
  }

  if (type === 'extra-light') {
    return 'extra-light';
  }

  if (type === 'dotted') {
    return 'dotted';
  }

  return null;
};

const getMarginTopStyles = ({ marginTop }) => {
  if (marginTop !== 'none') {
    return css.resolve`
      hr {
        margin-top: ${marginTop};
      }
    `;
  }

  return { className: '', styles: '' };
};

const getMarginBottomStyles = ({ marginBottom }) => {
  if (marginBottom !== 'none') {
    return css.resolve`
      hr {
        margin-bottom: ${marginBottom};
      }
    `;
  }

  return { className: '', styles: '' };
};

const Hr = ({
  className = '',
  marginTop = 'none',
  marginBottom = 'none',
  type = 'regular',
  ...rest
}) => {
  const typeClass = getTypeClass(type);
  const { className: marginTopClass, styles: marginTopStyles } = getMarginTopStyles({ marginTop });
  const { className: marginBottomClass, styles: marginBottomStyles } = getMarginBottomStyles({
    marginBottom,
  });
  const classNameModified = cx(className, typeClass, marginTopClass, marginBottomClass);

  return (
    <>
      <hr aria-hidden className={classNameModified} {...rest} />
      <style jsx>{`@import './Hr.scoped.scss';`}</style>
      {marginTopStyles}
      {marginBottomStyles}
    </>
  );
};

Hr.propTypes = {
  /** passed in style classes */
  className: PropTypes.string,
  /** Turns on or off top margin of heading */
  marginTop: PropTypes.string,
  /** Turn on or off bottom margin for footer */
  marginBottom: PropTypes.string,
  /** Style of hr */
  type: PropTypes.oneOf(['regular', 'light', 'extra-light', 'border', 'dotted']),
};

export default Hr;
